module.exports = __webpack_public_path__ + "img/s14401.a7de6a80.webp";